export default "__VITE_ASSET__CFRtRLmd__"